<template>
	<div>
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="entry-form">
			<el-form-item label="机构名称">
				<el-input v-model="ruleForm.orgainzName"></el-input>
				</el-form-item>
			<el-form-item label="联系人">
				<el-input v-model="ruleForm.contractUser"></el-input>
			</el-form-item>
			<el-form-item label="联系电话" prop="contractPhone">
				<el-input v-model="ruleForm.contractPhone"></el-input>
			</el-form-item>
			<el-form-item label="服务内容">
				<el-input type="textarea" v-model="ruleForm.serviceContent"></el-input>
			</el-form-item>
			<div class="entry-form-buttons">
				<el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
				<el-button style="margin-right: 70px;" @click="resetForm('ruleForm')">重置</el-button>
			</div>
		</el-form>
	</div>
</template>

<script>
import { residenceApplication } from '@/api';
export default {
	name: 'apply-entry',
	data() {
		var validateTel = (rule, value, callback) => {
			if (!/^1(3|4|5|6|7|8)\d{9}$/.test(value)) {
				return callback(new Error('请输入正确的手机号'));
			} else {
				callback();
			}
		};
		return {
			ruleForm: {
				orgainzName: '', //机构名称
				contractUser: '', //联系人
				contractPhone: '', //联系电话
				serviceContent: '' //服务内容
			},
			rules: {
				contractPhone: [
					{ validator: validateTel, trigger: 'blur' }
				],	
			}
		};
	},
	methods: {
		submitForm(formName) {
			let _this = this;
			_this.$refs[formName].validate(valid => {
				if (valid) {
					residenceApplication(_this.ruleForm).then(res => {
						if (res.code == 0) {
							this.$message({
							  message: '提交成功',
							  type: 'success'
							});
						}
					});
				} else {
					return false;
				}
			});
		},
		//重置
		resetForm(formName) {
			this.$refs[formName].resetFields();
		}
	}
};
</script>

<style lang="scss" scoped>
.entry-form {
	width: 90%;
	margin: 0 auto;

	.entry-form-buttons {
		display: flex;
		flex-direction: row;
		justify-content: center;
		.el-button {
			width: 200px;
		}
	}

	/deep/.el-form-item__label {
		font-size: 16px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/apply-entry.vue